// 配置默认url等
const url = {
  // 本地测试api
  // host: 'http://localhost:3000/api'
  // host: 'https://www.easy-mock.com/mock/5d69358d05e4050ee2e85e16/via-site-develop-api'
  // 线上测试环境
  // host: 'http://test-api.via-app.cn:2015/api'
  // 线上正式环境
  //   host: 'http://api.via-app.cn:2015/api'
  host: 'http://118.126.108.48:2015/api'
}

export default url
